declare let FreshworksWidget: any;

let inserting = false;

export function initFreshchat(id: string, appName: string, user: any) {
  const scriptUrl = 'https://euc-widget.freshworks.com/widgets/' + id + '.js';

  const alreadyExists = inserting || (typeof FreshworksWidget !== 'undefined' && document.querySelector('script[src="' + scriptUrl + '"]'));

  if (alreadyExists) {
    setFreshchatUser(appName, user);
  } else {
    createFreshChat(id);

    const node = document.createElement('script');
    node.type = 'text/javascript';
    node.src = scriptUrl;
    node.onload = () => {
      FreshworksWidget('hide', 'launcher');
      setFreshchatUser(appName, user);
    };

    inserting = true;
    document.querySelector('body').appendChild(node);
  }
}

export function createFreshChat(id = null) {
  window['fwSettings'] = {
    'widget_id': id
  };
  /* tslint:disable */
  // @ts-ignore
  !function () { if ("function" != typeof window["FreshworksWidget"]) { var n = function () { n.q.push(arguments) }; n.q = [], window['FreshworksWidget'] = n } }()
}

export function setFreshchatUser(appName: string, user: any) {
  if (typeof FreshworksWidget !== 'undefined' && appName && user) {
    FreshworksWidget('identify', 'ticketForm', {
      name: user.last_name ? user.first_name + ' ' + user.last_name : '',
      email: user.email,
      subject: '[' + appName.toUpperCase() + '] '
    });
  }
}
